module.exports = __webpack_public_path__ + "img/ic_32_profile_gesundheit.b2b98459.svg";